<script setup>
  const props = defineProps({
    padding: {
      type: Boolean,
      default: true
    },
    contentType: {
      type: String,
      default: 'null'
    }
  })
</script>

<template>
  <div
    :class="['jwx-page-block', 'jwx-data-container', {'jwx-page-block--padding-off': !props.padding}]"
    :data-content="props.contentType"
  >
    <slot></slot>
  </div>
</template>